var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 24,
    viewBox: "0 0 37 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.525 9.06C28.505 3.885 23.96 0 18.5 0C14.165 0 10.4 2.46 8.525 6.06C4.01 6.54 0.5 10.365 0.5 15C0.5 19.965 4.535 24 9.5 24H29C33.14 24 36.5 20.64 36.5 16.5C36.5 12.54 33.425 9.33 29.525 9.06ZM29 21H9.5C6.185 21 3.5 18.315 3.5 15C3.5 11.925 5.795 9.36 8.84 9.045L10.445 8.88L11.195 7.455C12.62 4.71 15.41 3 18.5 3C22.43 3 25.82 5.79 26.585 9.645L27.035 11.895L29.33 12.06C31.67 12.21 33.5 14.175 33.5 16.5C33.5 18.975 31.475 21 29 21ZM12.5 13.5H16.325V18H20.675V13.5H24.5L18.5 7.5L12.5 13.5Z",
    fill: "#916246"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.1c7e613c7d8b74144e7ed1ee5920a9db.svg";
export { ForwardRef as ReactComponent };